import { Div, Icon } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useCompetitionsList } from "./useCompetitionsList";
import CompetitionsList from "./CompetitionsList";

export default function CompetitionsListScreen({ navigation }: MainStackScreenProps<"competitions-list">) {
  const { competitions, loading, refreshCompetitions } = useCompetitionsList();

  const onCompetitionPress = (competitionId: number, competitionName: string) => {
    navigation.navigate("competition-detail", { competitionId, competitionName });
  };

  return (
    <ScreenLayout
      header={{ center: "COMPETITIONS", left: <Icon name="menu" size={24} onPress={navigation.toggleDrawer} /> }}
    >
      <CompetitionsList
        competitions={competitions}
        loading={loading}
        onCompetitionPress={onCompetitionPress}
        onRefresh={refreshCompetitions}
      />
    </ScreenLayout>
  );
}
